<template>
  <div class="add-new-customer">
    <title-bar
      submitBtn
      :submitBtnTitle="$t('messages.customerUpdate')"
      :title="$t('messages.customerUpdate')"
      @submitPressed="submitPressed"
    />
    <customer-form
      v-if="user"
      :userObject="user"
      :action="action"
      @clearAction="action = null"
    />
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar.vue";
import CustomerForm from "./components/CustomerForm.vue";

export default {
  components: {
    TitleBar,
    CustomerForm,
  },
  data() {
    return {
      user: null,
      action: null,
    };
  },
  created() {
    this.loadCustomer();
  },
  methods: {
    loadCustomer() {
      const id = this.$route.params.id;
      this.$Users.getResource({ id }).then((response) => {
        this.user = response.data;
        if(!this.user.address) {
          this.user.address = {}
        }
      });
    },
    submitPressed() {
      this.action = "update";
    },
  },
};
</script>
